module.exports = __webpack_public_path__ + "static/img/inviteFriendsToEarnBg.21f21fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/inviteFriendsToEarnBg.png
// module id = A8li
// module chunks = 0